import styled from 'styled-components';

const mapLabelSize = (v) => {
  switch (v) {
    case 1:
      return '24px';
    case 2:
      return '20px';
    case 3:
      return '16px';
    default:
      return '16px';
  }
};

const mapLabelColor = (v) => {
    switch (v) {
      case 'success':
        return '#10B981';
      case 'warning':
        return '#DC2626';
      default:
        return '#6B7280';
    }
  };

export const Label = styled.label.attrs({
  className: 'text-black',
})`
  color: ${({ type }) => mapLabelColor(type)};
  font-size: ${({ level }) => mapLabelSize(level)};
  font-weight: 400;
`;

export const ButtonWrapper = styled.div.attrs({
  className: 'flex w-full',
})`
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-left: -5px;
  margin-right: -5px;
`

export const Button = styled.button`
  font-size: 16px;
  color: #ffffff;
  margin-top: 15px;
  padding: 8px 24px;
  border: 0px;
  border-radius: 10px;
  cursor: pointer;
  flex: 1;
  margin-left: 5px;
  margin-right: 5px;
`;

export const LeaveButton = styled(Button)`
  background-color: #10B981;

  &:hover {
    background-color: #34D399;
  }
`

export const EndButton = styled(Button)`
  background-color: #6B7280;

  &:hover {
    background-color: #9CA3AF;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 5px;
  color: #DC2626;
  background-color: transparent;
  border: 0px;
  cursor: pointer;
  font-size: 18px;

  &:hover {
    color: #EF4444;
  }
`
